module.exports = ".msg-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  line-height: 1.4;\n  color: #fff;\n  word-break: break-word;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/chat/childs/message/message.component.less
// module id = 556
// module chunks = 0